import { graphql } from 'react-relay';

export const fileLinkFragment = graphql`
    fragment FileLink_fileLink on FileLink {
        header
        text
        url
        date
        format
        size
        smallicon
        largeicon
    }
`;
